import { spawn } from 'redux-saga/effects';

import { watchGetAutoSignin } from './getAutoSignin';

export default function* saga() {
  yield spawn(watchGetAutoSignin);
}
